module.exports = __webpack_public_path__ + "static/bulkPurchaseImage-6987be8b9296358a0ad3f1821d707bd7.png";